var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFrame7(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_16528_1226)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.0029 12.001C13.0196 12.0004 14.0132 11.6984 14.8582 11.1332C15.7032 10.568 16.3617 9.76491 16.7504 8.82552C17.139 7.88614 17.2405 6.8526 17.0419 5.85557C16.8432 4.85854 16.3535 3.94278 15.6345 3.22405C14.9155 2.50533 13.9995 2.01592 13.0024 1.81768C12.0053 1.61945 10.9718 1.72129 10.0326 2.11033C9.09332 2.49938 8.29051 3.15816 7.72562 4.00339C7.16073 4.84863 6.85913 5.84237 6.85893 6.859C6.8588 7.53446 6.99178 8.20333 7.25026 8.82737C7.50875 9.45142 7.88768 10.0184 8.3654 10.4959C8.84312 10.9735 9.41026 11.3522 10.0344 11.6104C10.6585 11.8687 11.3275 12.0014 12.0029 12.001ZM15.6029 13.286H14.9319C14.0139 13.7094 13.0149 13.9286 12.0039 13.9286C10.993 13.9286 9.99399 13.7094 9.07593 13.286H8.40293C6.97076 13.286 5.59725 13.8549 4.58455 14.8676C3.57186 15.8803 3.00293 17.2538 3.00293 18.686L3.00293 20.357C3.00293 20.8683 3.20606 21.3587 3.56763 21.7203C3.9292 22.0819 4.41959 22.285 4.93093 22.285H19.0689C19.5803 22.285 20.0707 22.0819 20.4322 21.7203C20.7938 21.3587 20.9969 20.8683 20.9969 20.357V18.684C20.9964 17.2532 20.4281 15.8811 19.4167 14.869C18.4054 13.8569 17.0337 13.2876 15.6029 13.286Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_16528_1226"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame7);
export default __webpack_public_path__ + "static/media/Frame (7).078dc20a.svg";
export { ForwardRef as ReactComponent };